import styled from 'styled-components';
import { useState } from "react";

import { FaRegEdit } from "react-icons/fa";
import {
  TableCell
} from "@material-ui/core";

const P = {
  HandleDiv: styled.div`
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
  `,

  HeaderInnerDiv: styled.div`
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-end;
  `,

  FilterSelect: styled.select`
      width: 250px;
      height: 52px;
      
      margin-top: 20px;
  `,

  FilterDiv: styled.div`
      display: flex;
      justify-content: center;
      align-items: center;
  `,

  EndP: styled.div`
    font-weight: bold;
    color: #EA6A6A;  
  `,

  EditableDiv: styled.div`
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
  `,

  FaRegEditIcon: styled(FaRegEdit)`
      margin-left: 10px;
      font-size: 20px;
      cursor: pointer;
      flex-shrink: 0;
      &:hover {
          color: #3085D6;
      }
  `,

  TableCellEdit: styled(TableCell)`
      text-align: center;
  `,

  TableCellHead: styled(TableCell)`
      text-align: center;
      cursor: default;
      font-weight: 700;
      font-size: 16px;
  `,

  TableCellHeadDiv: styled.div`
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
  `,

  sortBtn: styled.img`
      width: 18px;
      height: 18px;
      opacity: 0.5;

      &:hover {
          opacity: 1;
      }
  `,

  /*    createPlan    */

  TotalDiv: styled.div`
      width: 80%;
      
      position: relative;
      left: 10%;
      
      font-size: 15px;
    
      border-radius: 5px;
      
      display: flex;
      justify-content: center;
      align-items: center;
  `,

  InnerTotalDiv: styled.div`
      background-color: white;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
      border-radius: 20px;

      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      width: 50%;
      margin: 60px 0;
      padding: 80px 0;
  `,

  TitleH4: styled.div`
      font-size: 28px;
      font-weight: bold;
      
      margin-bottom: 50px;
  `,

  BasicDiv: styled.div` // 세로 정렬
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      
      width: 380px;
      margin-bottom: 40px;
  `,


  BasicLabel: styled.div`
      margin-bottom: 4px;
      font-weight: bolder;
  `,

  Input: styled.input`
      width: 380px;
      height: 40px;

      border: 1px solid #cccccc;
      border-radius: 6px;

      font-size: 13px;

      &:focus {
          border-color: #536DFE;
          outline: none;
      }
  `,

  CheckResultP: styled.p`
      color: #FF6868;
      font-size: 15px;
      font-weight: bold;
      
      white-space: pre-line;
      
      margin: 0;
  `,

  ClassSelect: styled.select`
      width: 380px;
      height: 40px;
      
      border: 1px solid #cccccc;
      border-radius: 6px;

      font-size: 13px;

      &:focus {
          border-color: #536DFE;
          outline: none;
      }
  `,

  SubmitBtn: styled.button`
      width: 190px;
      height: 54px;

      background-color: #536DFE;
      font-size: 15px;
      color: white;

      border: none; /* 테두리 제거 */
      border-radius: 5px; /* 모서리 둥글게 */
      cursor: pointer; /* 버튼에 마우스 올릴 때 포인터 커서 */

      margin-top: 40px;
      
      &:hover {
          background-color: #4154d0; /* 호버 시 색상 변경 */
      }
  `,
}

export default P;